import { createContext } from 'react'

const PickContext = createContext()

export default PickContext
